import * as Yup from 'yup';

const validationSchema = () =>
  Yup.object().shape({
    contract: Yup.object()
      .nullable()
      .required('SANTANDER_REPORTS.CONTRACT_REQUIRED'),
    continueBilling: Yup.boolean()
      .required('SCHEMA_ERRORS.REQUIRED_FIELD')
      .oneOf([true, false], 'SCHEMA_ERRORS.REQUIRED_FIELD')
  });

export default validationSchema;
